var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
/**
 * @deprecated utiliser `ToggleV2`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var Toggle = React.forwardRef(function (_a, ref) {
    var name = _a.name, label = _a.label, labelGauche = _a.labelGauche, _b = _a.texteEtatActive, texteEtatActive = _b === void 0 ? "Activé" : _b, _c = _a.texteEtatDesactive, texteEtatDesactive = _c === void 0 ? "Désactivé" : _c, texteAide = _a.texteAide, disabled = _a.disabled, bordureEnBas = _a.bordureEnBas, otherProps = __rest(_a, ["name", "label", "labelGauche", "texteEtatActive", "texteEtatDesactive", "texteAide", "disabled", "bordureEnBas"]);
    var toggleClassName = "fr-toggle";
    if (labelGauche) {
        toggleClassName += " fr-toggle--label-left";
    }
    if (bordureEnBas) {
        toggleClassName += " fr-toggle--border-bottom";
    }
    return (React.createElement("div", { className: toggleClassName },
        React.createElement("input", __assign({ 
            // @ts-ignore
            ref: ref, name: name, type: "checkbox", className: "fr-toggle__input", "aria-describedby": name + "-hint-text", id: name, disabled: disabled }, otherProps)),
        React.createElement("label", { className: "fr-toggle__label", htmlFor: name, "data-fr-checked-label": texteEtatActive, "data-fr-unchecked-label": texteEtatDesactive }, label),
        texteAide ? (React.createElement("p", { className: "fr-hint-text", id: name + "-hint-text" }, texteAide)) : null));
});
export default Toggle;
